const MODULES = {
  MEETINGS: 'MEETINGS',
  GOALS: 'GOALS',
  REVIEWS: 'REVIEWS',
  SURVEYS: 'SURVEYS',
  RECOGNITIONS: 'RECOGNITIONS',
  FEEDBACK: 'FEEDBACK',
  TASKS: 'TASKS',
  NOTES: 'NOTES',
  GENERAL: 'GENERAL',
  AI: 'AI',
  LICENSE: 'LICENSE',
  INDIVIDUAL_DEVELOPMENT_PLAN: 'INDIVIDUAL_DEVELOPMENT_PLAN',
  NOTIFICATIONS: 'NOTIFICATIONS',
  SUCCESSION_PLAN: 'SUCCESSION_PLAN',
  LEARNING_MATERIALS: 'LEARNING_MATERIALS',
  ROLES: 'ROLES',
  COMPETENCY_LIBRARY: 'COMPETENCY_LIBRARY',
  MY_ORGANIZATION: 'MY_ORGANIZATION',
  EXTERNAL_API: 'EXTERNAL_API'
}

export { MODULES }
